import  * as React from "react";
import { observer } from "mobx-react";
import { ISkidAndRollParameterLineParams } from "./ISkidAndRollParameterLineParams";

@observer 
export class SkidAndRollParameterLine extends React.Component<ISkidAndRollParameterLineParams>{

    constructor(props: ISkidAndRollParameterLineParams) {
        super(props, undefined);
    }
    render() {
        return <line className="SkidAndRollParameterLine" x1={this.props.x1} y1={this.props.y1} x2={this.props.x2} y2={this.props.y2}></line>;
    }
}
